import Vue from 'vue'

export default {

    /**
     * Searches for groups in the API
     *
     * @param {string} search
     * @return {Promise<unknown>}
     */
    async getGroups(search){
        let res = await Vue.axios.get('/groups', {
            params: {
                search: search,
            }
        })

        return res.data
    }
}